import React from 'react'
import parse, { domToReact } from 'html-react-parser'
import { formatCurrency } from './helpers'

export const htmlToReactWithReplace = (html, bid, changeSelected) => {
  if (bid.response_datetime) {
    return parse(html)
  }
  function getIcon(is_selected, option_group_name) {
    if (is_selected & !option_group_name) {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 50">
            <rect x="5" y="5" width="40" height="40" fill="green" stroke="green" stroke-width="2"/>
            <polyline points="15 24 24 35 34 13" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`
    } else if (!is_selected && !option_group_name) {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 50">
            <rect x="5" y="5" width="40" height="40" fill="white" stroke="gray" stroke-width="2"/>
          </svg>`
    } else if (is_selected && option_group_name) {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 50">
            <circle cx="25" cy="25" r="20" fill="green" stroke="green" stroke-width="2"/>
            <circle cx="25" cy="25" r="17" fill="white"/>
            <circle cx="25" cy="25" r="12" fill="green"/>
          </svg>`
    } else if (!is_selected && option_group_name) {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 50">
            <circle cx="25" cy="25" r="20" fill="white" stroke="gray" stroke-width="2"/>
          </svg>`
    }
  }

  const tdOptions = {
    replace(domNode) {
      if (domNode.name === 'td' && domNode.attribs.class === 'select_item') {
        const uid = domNode.attribs['data-uid']
        const bidItem = bid?.bid_items?.find((item) => item.uid === uid)
        const { is_selected, option_group_name } = bidItem
        return <td>{parse(getIcon(is_selected, option_group_name))}</td>
      } else if (
        domNode.name === 'td' &&
        domNode.attribs['data-column'] === 'item_subtotal'
      ) {
        const uid = domNode.attribs['data-uid']
        const bidItem = bid?.bid_items?.find((item) => item.uid === uid)
        return (
          <td className={domNode.attribs.class}>
            {bidItem.is_selected ? formatCurrency(bidItem.item_total) : ''}
          </td>
        )
      }
    }
  }
  const replace = (domNode) => {
    if (
      domNode.name === 'a' &&
      domNode.attribs &&
      domNode.attribs.href &&
      domNode.attribs.href.slice(0, 4) !== 'http'
    ) {
      return (
        <a
          className={domNode.attribs.class}
          href={domNode.attribs.href}
          onClick={(e) => {
            e.preventDefault()
            // navigate(domNode.attribs.href)
          }}>
          {domNode.children[0].data}
        </a>
      )
    } else if (domNode.name === 'tr' && domNode.attribs['data-uid']) {
      const uid = domNode.attribs['data-uid']
      const bidItem = bid?.bid_items?.find((item) => item.uid === uid)
      const { is_selected, is_required } = bidItem
      return (
        <tr
          className={`item${is_required ? '' : ' pointer'}${is_selected ? '' : ' not_selected_tr'}`}
          onClick={is_required ? null : () => changeSelected({ uid })}>
          {domToReact(domNode.children, tdOptions)}
        </tr>
      )
    } else if (
      domNode.name === 'td' &&
      domNode.attribs['data-td'] === 'total'
    ) {
      let total = 0
      bid?.bid_items.map((item) => {
        if (item.is_selected) {
          total += item.item_total
        }
      })
      return <td className={domNode.attribs.class}>{formatCurrency(total)}</td>
    }
  }
  return parse(html, { replace })
}
